import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";
import { TiUser } from "react-icons/ti";
import { FaFemale, FaMale } from "react-icons/fa";
import { STR_CHAT_NOW, STR_FEMALE, STR_MALE } from "../Strings";
import { BsChatDots } from "react-icons/bs";
import { MdLocationPin } from "react-icons/md";

export default function View({ data }) {
  const appContext = useContext(AppContext);

  /* Place states here */

  function startChat() {
    if (appContext.currentUserData.subscriptionStatus === 'active') {
      appContext.navTo({
        item: 'view',
        subItem: 'chatroom',
        extraItem: data.userId,
      })
    } else {
      appContext.tellPurchaseMessage();
    }

  }

  function openLogin() {
    appContext.navTo({
      item: 'view',
      subItem: 'login',
    })
  }

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex text-secondary">

          <h6
            className="align-self-center mNoMargin mOneLineText font-bold"
            style={{
              fontSize: "18px",
              paddingLeft: "0px",
              textTransform: "capitalize",
            }}
          >
            {data.username}
          </h6>
        </div>

        {
          (data.cover) ?
          <img
            src={CDN_URL+data.cover}
            style={{
              width: "100%",
              height: "auto",
              borderRadius: "10px"
            }}
            className="mt-2 mb-2"
          />
          :""
        }

        <pre
          className="mt-2"
          style={{
            fontSize: "16px",
            paddingLeft: "0px",
          }}
        >
          {data.description}
        </pre>

        <h6
          className="mt-4 d-flex"
          style={{
            fontSize: "12px",
            paddingLeft: "0px",
            textTransform: "capitalize",
          }}
        >
          <MdLocationPin size={18} className="text-primary align-self-center" />
          <span className="align-self-center">{data.region}{(data.district) ? <>, {data.district}</> : ""}</span>
        </h6>

        <div className="d-flex justify-content-between">
          <span
            className="badge bg-secondary align-self-center font-light"
            style={{
              fontSize: "12px",
              flexShrink: "0",
            }}
          >
            {(data.gender === 'female') ? STR_FEMALE[appContext.language] : STR_MALE[appContext.language]}
          </span>

          {
            (appContext.auth && appContext.currentUserData) ?
            <>
            {
              (
                Number(data.userId) !== Number(appContext.currentUserData.id)
              ) ?
                <div 
                  className="d-flex align-self-center mNoMargin" 
                  style={{
                    flexShrink: "0",
                  }}
                  onClick={startChat}
                >
                  <BsChatDots
                    className="align-self-center mNoMargin text-secondary"
                    size={30}
                    
                  />

                  <h6
                    className="align-self-center mNoMargin text-secondary font-bold"
                    style={{
                      fontSize: "14px",
                      paddingLeft: "5px"
                    }}
                  >
                    {STR_CHAT_NOW[appContext.language]}
                  </h6>
                </div>
                : ""
            }
            </>:
            <div 
              className="d-flex align-self-center mNoMargin" 
              style={{
                flexShrink: "0",
              }}
              onClick={openLogin}
            >
              <BsChatDots
                className="align-self-center mNoMargin text-secondary"
                size={30}
                
              />

              <h6
                className="align-self-center mNoMargin text-secondary font-bold"
                style={{
                  fontSize: "14px",
                  paddingLeft: "5px"
                }}
              >
                {STR_CHAT_NOW[appContext.language]}
              </h6>
            </div>
          }
        </div>
      </div>
    </div>
  )
}
